import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Var bokar jag kunskapsprovet?";
const SHORT_ANSWER = "Hos kommunens tillståndsenhet, normalt efter att din ansökan kommit in och granskats.";

export const Route = createFileRoute("/fraga/var-bokar-jag-provet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Var bokar jag kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Du kan inte boka provet innan du har en pågående ansökan. Kontakta tillståndsenheten i kommunen där du söker tillstånd; bokningsbara tider varierar mellan veckor och månader beroende på kommunens storlek."}
      source={{ label: "Folkhälsomyndigheten – Kunskapsprov", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/kunskapsprov/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/boka-kunskapsprovet", label: "Boka kunskapsprovet – steg för steg" }}
      related={[{"to": "/fraga/far-jag-gora-provet-pa-engelska", "label": "Får jag göra kunskapsprovet på engelska?"}, {"to": "/fraga/far-jag-tolk-pa-provet", "label": "Får jag använda tolk på kunskapsprovet?"}, {"to": "/fraga/vad-hander-om-jag-blir-underkand", "label": "Vad händer om jag blir underkänd på kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Var bokar jag kunskapsprovet?" },
      { name: "description", content: "Hos kommunens tillståndsenhet, normalt efter att din ansökan kommit in och granskats." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/var-bokar-jag-provet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/var-bokar-jag-provet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/var-bokar-jag-provet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Var bokar jag kunskapsprovet", url: "https://alkoholprovet.se/fraga/var-bokar-jag-provet" },
      ]),
    ],
  }),
});
